module.exports = __webpack_public_path__ + "static/img/recruit_title_logo.2779232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/recruit_title_logo.png
// module id = 5Wjt
// module chunks = 0